module.exports = __webpack_public_path__ + "img/login_background.54ee9ebe.png";